import { pick } from 'ramda';
import React, { FC } from 'react';
import { callOrUse } from '../../callOrUse';
import { useMediaManagerSDK } from '../../hooks/useMediaManagerSDK';
import { IUseMediaManagerSDK } from '../../hooks/useMediaManagerSDK/useMediaManagerSDK.types';

type TGetNeededProps = ((any: any & IUseMediaManagerSDK) => IUseMediaManagerSDK) | IUseMediaManagerSDK;

/**
 * @deprecated use "useMediaManagerSDK"
 */
export const withMediaManagerSDK =
  (getNeededProps: TGetNeededProps = pick(['source', 'currentFolder'])) =>
  (BaseComponent) => {
    const WithMediaManagerSDK: FC = (props) => {
      const handlers = useMediaManagerSDK(callOrUse(getNeededProps, props));

      return <BaseComponent {...props} {...handlers} />;
    };

    return WithMediaManagerSDK;
  };
